// @flow

import { createReducer } from 'redux-act';

import {
  setPrefetchStatus,
  setAppWorking,
  unsetAppWorking,
  patchDomainContactsStart,
  patchDomainContactsEnd,
  setPayLaterProcess,
  setCorporatePackPrice,
  setPreferencesDialogOpen,
} from './actions';

import type { State } from './types';

const initialState: State = {
  isComingFromPrefetch: false,
  isWorking: false,
  isPatchingDomainContacts: false,
  isPayLaterProcess: false,
  corporatePackMonthlyPrice: {
    currency: undefined,
    priceAfterTaxes: undefined,
    priceBeforeTaxes: undefined,
  },
  layout: {
    preferencesDialogOpen: false,
  },
  temporaryCart: {
    cartId: '',
    distinctProducts: 0,
  },
};

export default (createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [setPreferencesDialogOpen]: (state: State, open: boolean): State => {
      if (open === state.layout.preferencesDialogOpen) {
        return state;
      }
      return {
        ...state,
        layout: { ...state.layout, preferencesDialogOpen: open },
      };
    },
    // $FlowFixMe[invalid-computed-prop]
    [setPrefetchStatus]: (state: State, status: boolean): State => ({
      ...state,
      isComingFromPrefetch: status,
    }),

    // $FlowFixMe[invalid-computed-prop]
    [setAppWorking]: (state: State): State => ({
      ...state,
      isWorking: true,
    }),
    // $FlowFixMe[invalid-computed-prop]
    [unsetAppWorking]: (state: State): State => ({
      ...state,
      isWorking: false,
    }),

    // $FlowFixMe[invalid-computed-prop]
    [patchDomainContactsStart]: (state: State): State => ({
      ...state,
      isPatchingDomainContacts: true,
    }),

    // $FlowFixMe[invalid-computed-prop]
    [patchDomainContactsEnd]: (state: State): State => ({
      ...state,
      isPatchingDomainContacts: false,
    }),

    // $FlowFixMe[invalid-computed-prop]
    [setPayLaterProcess]: (state: State): State => ({
      ...state,
      isPayLaterProcess: true,
    }),

    // $FlowFixMe[invalid-computed-prop]
    [setCorporatePackPrice]: (
      state: State,
      price: State['corporatePackMonthlyPrice'],
    ): State => {
      if (price.currency === state.corporatePackMonthlyPrice.currency) {
        return state;
      }

      return {
        ...state,
        corporatePackMonthlyPrice: price,
      };
    },
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
